export const tabEvent = (key, activeTab) => new CustomEvent('setActiveTab', {
    detail: {
        key,
        activeTab,
    },
    bubbles: true,
    composed: true,
});
export const updateNrOfTabs = (key, nrOfTabs) => new CustomEvent('updateNrOfTabs', {
    detail: {
        key,
        nrOfTabs,
    },
    bubbles: true,
    composed: true,
});
//# sourceMappingURL=tabEvent.js.map